import { getSubscriptions } from '@innovyze/stylovyze';
import { fullAccess } from '@innovyze/shared-utils';

/**
 * True when the current user may mutate Cost Tables (holds the Full
 * entitlement). View-only and inspection-only users return false and
 * must see a read-only UI.
 */
export const useHasEditAccess = (): boolean => fullAccess(getSubscriptions());
